import React from 'react'

import './footer.scss'

function DisplayFooter(): JSX.Element {
  return <footer />
}

export default DisplayFooter
